import BooleanFilter from "@search/store/filters/primitive/BooleanFilter";

class ExtraYardsFilter extends BooleanFilter {
  constructor(value: boolean) {
    super({
      defaultValue: false,
      label: "Extra Yards",
      name: "extraYards",
      value,
    });
  }
}

export default ExtraYardsFilter;
export { ExtraYardsFilter };
